export default __webpack_public_path__ + "static/media/img_baseRattle_lemon_p.30840891.jpg";